module.exports = __webpack_public_path__ + "img/pie-chart-bg-dark.07d57f72.svg";